import { render } from "./About-View.vue?vue&type=template&id=1f73f21d"
const script = {}
script.render = render

export default script